.eds-header {
  min-width: 0;
  width: 100%;
}

/* The title and subtitle truncate with `white-space: nowrap`, whose min-content
   width is the whole string. A flex item defaults to `min-width: auto`, so
   without these overrides every wrapper refuses to shrink below that string and
   the header overflows its container (e.g. a resized panel) instead of
   ellipsizing. */
.eds-header--body,
.eds-header--content,
.eds-header--title-block,
.eds-header--title,
.eds-header--subtitle {
  min-width: 0;
}

.eds-header--title-block {
  padding-block: var(--eds--padding-4);
}

/* The row gap already separates the title from the subtitle below it. */
.eds-header--title-block--with-subtitle {
  padding-block-end: var(--eds--padding-none);
}

.eds-header--title {
  flex: 0 1 auto;
  overflow: hidden;
}

.eds-header--subtitle {
  overflow: hidden;
  padding-block-end: var(--eds--padding-4);
}

/* Never shrinks or ellipsizes — the title (`.eds-header--title`, `flex: 0 1
   auto`) gives up space first when the row is squeezed. */
.eds-header--status-badge {
  flex: none;
}

/* Inline (horizontal) padding stays constant per size; block (vertical) padding
   is tightened to track the title typography. */
.eds-header--size-s {
  padding-block: var(--_header-padding-block, var(--eds--padding-8));
  padding-inline: var(--_header-padding-inline, var(--eds--padding-16));
}

.eds-header--size-m {
  padding-block: var(--_header-padding-block, var(--eds--padding-12));
  padding-inline: var(--_header-padding-inline, var(--eds--padding-16));
}

.eds-header--size-l {
  padding-block: var(--_header-padding-block, var(--eds--padding-16));
  padding-inline: var(--_header-padding-inline, var(--eds--padding-24));
}
